var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'mixin', 'core', 'component/range-selector', 'component/report/search', 'component/report/editing', 'app-common/component/notification', 'app-common/component/loader', 'app-common/view/toolbar', 'template/report/header.htm', 'common/location'], function($, _, _s, Backbone, mixin, core, rangeSelector, search, editing, NotificationSupport, loader, ToolbarView, headerTemplate, location) {
  /*
  # Base class for Reports section
  # It contains settings and initializers for related components - search, rangeSelector, etc
  */

  var ReportView;
  return ReportView = (function(_super) {

    __extends(ReportView, _super);

    function ReportView() {
      ReportView.__super__.constructor.apply(this, arguments);
    }

    ReportView.prototype.reportType = '';

    /*
    # @param {Object} options contains id, title, icon, template
    	    # @param {Array} params additional information passed to widget with ID
    */


    ReportView.prototype.initialize = function(options, params) {
      ReportView.__super__.initialize.apply(this, arguments);
      this.settings.title = options.title;
      this.settings.icon = options.icon;
      this.settings.attachedFeatures = ['search'];
      this.settings.params = params;
      this.settings.options = options;
      this.settings.statusManage = false;
      this.data = {
        metadata: []
      };
      this.templates = {
        landing: options.template
      };
      this.UILoaded = false;
      if (this.hasFeature('date-range')) {
        this.initDateRangeFeatureData();
        this.on('report:date-change', this.dateChangeAction);
      }
      if (this.hasFeature('edit')) {
        this.initEditingHotkeys();
      }
      if (this.hasFeature('search')) {
        this.initSearchFeatureData();
        return this.on('report:search', this.searchAction);
      }
    };

    ReportView.prototype.initUI = function() {
      var template, _ref;
      this.render(this.templates.landing);
      template = _.template(headerTemplate, {
        settings: this.settings,
        downloadURL: this.settings.title !== 'Download' ? this.getDownloadUrl() : void 0,
        editFeature: this.hasFeature('edit'),
        searchFeature: this.hasFeature('search'),
        isBK: core.isCurrentClientBookkeeper(),
        overviewFeature: this.hasFeature('overview'),
        isLedgerSpecific: core.getLedgersById()[this.data.currentLedgerId] != null,
        hasOverviewDetails: this.hasOverviewDetails()
      });
      $('.widget .widget_header').html(template);
      this.UILoaded = true;
      if (this.hasFeature('date-range')) {
        this.initDateRangeFeatureUI();
      }
      if (this.hasFeature('edit')) {
        this.initEditFeature();
      }
      if (this.hasFeature('search')) {
        this.initSearchFeatureUI();
      }
      if (this.hasFeature('overview')) {
        this.initOverviewFeature();
      }
      $('.report-name').attr('aria-label', this.settings.title + ' Page');
      $('.control-button').click(function(e) {
        if (e.target !== e.currentTarget) {
          return;
        }
        return $(e.currentTarget).find('.control').click();
      });
      return (_ref = this.overviewView) != null ? _ref.on('overview-details-update', this.updateOverviewButton.bind(this)) : void 0;
    };

    ReportView.prototype.initReportDateIntervals = function() {
      if (this.settings.params.length === 4) {
        return this.updateReportIntervalFromURL(this.settings.params[1], this.settings.params[3]);
      } else {
        return this.updateReportURLFromInterval();
      }
    };

    ReportView.prototype.remove = function() {
      ReportView.__super__.remove.apply(this, arguments);
      rangeSelector.hide();
      $(document).off('keydown.start-editing');
      this.off('report:date-change');
      return this.off('report:search');
    };

    ReportView.prototype.updateReportIntervalFromURL = function(start, end) {
      var result;
      result = rangeSelector.changeIntervalByDates(start, end);
      if (!result) {
        return this.updateReportURLFromInterval();
      }
    };

    ReportView.prototype.setUrlWithParams = function(params) {
      var router, url;
      if (params == null) {
        params = [];
      }
      router = core.getRouter();
      url = (router.buildUrl(this.getType(), params, this.settings.options)).replace(/\+/g, '%20');
      this.settings.params = params;
      return router.navigate(url, {
        replace: true
      });
    };

    ReportView.prototype.updateUrl = function(updateObj) {
      var end, key, keyIndex, params, start, val, _ref;
      if (updateObj == null) {
        updateObj = {};
      }
      params = this.settings.params;
      _ref = this.getIntervalDates(true), start = _ref[0], end = _ref[1];
      _.extend(updateObj, {
        start: start,
        end: end
      });
      for (key in updateObj) {
        val = updateObj[key];
        if ((keyIndex = params.indexOf(key)) !== -1) {
          params[keyIndex + 1] = val;
        } else {
          params = _.union(params, [key, val]);
        }
      }
      return this.setUrlWithParams(params);
    };

    ReportView.prototype.getUrlParamValue = function(key) {
      var keyIndex;
      if (key == null) {
        key = '';
      }
      if ((keyIndex = this.settings.params.indexOf(key)) !== -1) {
        return this.settings.params[keyIndex + 1];
      }
    };

    ReportView.prototype.removeUrlParam = function(key) {
      var keyIndex, params;
      if (key == null) {
        key = '';
      }
      if ((keyIndex = this.settings.params.indexOf(key)) !== -1) {
        params = this.settings.params.filter(function(k, index) {
          return index !== keyIndex && index !== keyIndex + 1;
        });
        return this.setUrlWithParams(params);
      }
    };

    ReportView.prototype.updateReportURLFromInterval = function(optionalParams) {
      var end, params, start, _ref;
      if (optionalParams == null) {
        optionalParams = [];
      }
      _ref = this.getIntervalDates(true), start = _ref[0], end = _ref[1];
      params = _.union(optionalParams, ['start', start, 'end', end]);
      return this.setUrlWithParams(params);
    };

    ReportView.prototype.clearReportURL = function() {
      return this.setUrlWithParams([]);
    };

    ReportView.prototype.getIntervalDates = function(dashes, yyyyMMdd) {
      var format, intervalAsDates;
      if (dashes == null) {
        dashes = false;
      }
      if (yyyyMMdd == null) {
        yyyyMMdd = false;
      }
      format = dashes ? yyyyMMdd ? 'yyyy-MM-dd' : 'MM-dd-yyyy' : yyyyMMdd ? 'yyyy/MM/dd' : 'MM/dd/yyyy';
      intervalAsDates = rangeSelector.getIntervalAsDates();
      return [intervalAsDates.from.toString(format), intervalAsDates.to.toString(format)];
    };

    ReportView.prototype.initDateRangeFeatureData = function() {
      var _this = this;
      return rangeSelector.init(function() {
        return _this.trigger('report:date-change');
      });
    };

    ReportView.prototype.initDateRangeFeatureUI = function() {
      var summary;
      summary = $('.report-summary');
      this.showFeature('date-range');
      summary.show();
      return rangeSelector.initUI($('.date-range-button'), summary, this.data.metadata, this.settings.statusManage);
    };

    ReportView.prototype.initSearchFeatureData = function() {
      var _this = this;
      return search.setCallback(function(searchKey) {
        core.trackEvent('Transaction Searched');
        return _this.trigger('report:search', searchKey);
      });
    };

    ReportView.prototype.initSearchFeatureUI = function() {
      var _this = this;
      this.showFeature('search');
      search.init('.search-field');
      return $(document).on('keydown.start-editing', function(e) {
        if ((e.which || e.keyCode) === 85 && (core.isMac() ? e.metaKey : e.ctrlKey)) {
          e.preventDefault();
          $('.search-field').focus().select();
          return false;
        } else {
          return true;
        }
      });
    };

    ReportView.prototype.initEditFeature = function() {
      return this.showFeature('edit');
    };

    ReportView.prototype.initOverviewFeature = function() {
      return this.showFeature('overview');
    };

    ReportView.prototype.isEditHotkeyAllowed = function() {
      return !editing.isActive();
    };

    ReportView.prototype.hasOverviewDetails = function() {
      var _ref, _ref1;
      return (_ref = core.getLedgersById()[this.data.currentLedgerId]) != null ? (_ref1 = _ref.details) != null ? _ref1.length : void 0 : void 0;
    };

    ReportView.prototype.initEditingHotkeys = function() {
      var _this = this;
      return $(document).on('keydown.start-editing', function(e) {
        if (_this.isEditHotkeyAllowed() && (e.which || e.keyCode) === 69 && (core.isMac() ? e.metaKey : e.ctrlKey)) {
          e.preventDefault();
          _this.trigger('report:start-editing');
          return false;
        } else {
          return true;
        }
      });
    };

    ReportView.prototype.dateChangeAction = function() {
      return this.changeDownloadUrl();
      /*
      # @param {Array} data Array of objects with saved data
      */

    };

    ReportView.prototype.editAction = function(data) {
      /*
      # @param {string} searchKey
      */

    };

    ReportView.prototype.searchAction = function(searchKey) {};

    ReportView.prototype.updateOverviewButton = function() {
      var hasOverviewDetails, tooltipCopy;
      hasOverviewDetails = this.hasOverviewDetails();
      tooltipCopy = !hasOverviewDetails ? 'Overview' : 'Overview (Details)';
      this.$('#overview-show').toggleClass('active', hasOverviewDetails);
      return this.$('#overview-show .control-button__tip').html(tooltipCopy);
    };

    /*
    # @param {object} options
    # @param {array} params: [searchKey, ledgerID (optional)]
    */


    ReportView.prototype.searchLoad = function(options, params) {
      if (options == null) {
        options = {};
      }
      if (params == null) {
        params = [];
      }
      params = _.compact(params);
      params = params.map(encodeURIComponent);
      return core.getRouter().loadPage('search', params, options, 'Search: ' + options.queryVals.searchkey);
    };

    ReportView.prototype.addUnavailableMessage = function(promise) {
      var _this = this;
      return promise.fail(function() {
        loader.hide();
        _this.render('<div class="notification-area"></div>');
        return _this.showNotification({
          type: 'warning',
          text: 'Our apologies, we’re having trouble loading your report. Please check your internet connection and refresh the page. If the problem persists, please let your bookkeeping team know!'
        }, true);
      });
    };

    ReportView.prototype.changeDownloadUrl = function() {
      return $('#download-link').attr('href', this.getDownloadUrl());
    };

    ReportView.prototype.getDownloadUrl = function() {
      var client, clientId, endDate, intervalAsDates, intervalType, reportScale, reportsApiUrl, startDate;
      reportsApiUrl = location.apiRoot + location.reportingApiPath;
      client = core.getCurrentClient().toJSON();
      clientId = client.id;
      intervalType = rangeSelector.getIntervalType();
      reportScale = intervalType === 'YEAR' ? 'yearly' : intervalType === 'QUARTER' ? 'quarterly' : intervalType === 'MONTH' ? 'monthly' : 'custom';
      intervalAsDates = rangeSelector.getIntervalAsDates();
      endDate = intervalAsDates.to.toString('yyyy-MM-dd');
      startDate = intervalAsDates.from.toString('yyyy-MM-dd');
      if (this.data.currentLedgerId != null) {
        return "" + reportsApiUrl + "view/xls/" + clientId + "/" + this.data.currentLedgerId + "/" + startDate + "/" + endDate;
      } else if (this.reportType === 'balance-sheet') {
        return "" + reportsApiUrl + this.reportType + "/xls/" + clientId + "/" + reportScale + "/" + endDate;
      } else if (this.reportType === 'income-statement') {
        return "" + reportsApiUrl + this.reportType + "/xls/" + clientId + "/" + reportScale + "/" + startDate + "/" + endDate;
      } else {
        return "" + reportsApiUrl + this.reportType + "/xls/" + clientId + "/" + startDate + "/" + endDate;
      }
    };

    ReportView.prototype.prettyPath = function(pathStr) {
      if (_.isString(pathStr)) {
        return _s.titleize(pathStr.replace(/-/, " "));
      } else {
        return pathStr;
      }
    };

    return ReportView;

  })(mixin.of(ToolbarView, NotificationSupport));
});
